<template>
  <!-- 用户条款 author: zhangxiaofeng-->
  <div class="content-box privacy--main">
    <h2>
      广联达造价云管理平台服务用户使用协议
    </h2>
    <div class="part">
      导言：
      <br>
      欢迎您使用造价云管理平台服务！
    </div>
    <div class="part">
      本协议是由您（以下简称“您”）与广联达科技股份有限公司（以下简称“广联达”）所订立的协议，本协议自您确认接受之时起或自您使用广联达造价云管理平台服务的行为发生之时起（以时间在先者为准）生效。
    </div>
    <div class="part">
      本协议将对您使用广联达造价云管理平台服务的行为产生法律约束力,如您同意使用该服务将视为您已经知悉、理解并接受本协议的全部内容。因此，请您务必审慎阅读、充分理解各条款的内容，特别是免除或者限制责任的条款、争议解决和法律适用条款等(如果您是未满18周岁的未成年人，审阅时应由法定监护人陪同，并特别注意未成年人使用条款)。 如果您不同意本协议的任意内容，或者无法准确理解本协议条款的解释，请不要进行任何后续操作。否则，您的使用及任何操作行为，均视为已接受本协议约束。
    </div>
    <div class="part">
      一、账户注册
      <br>
      1.1 广联达账号的所有权归广联达，您完成注册手续后，获得广联达账号的使用权。您应提供及时、详尽及准确的个人资料，并不断更新注册资料，符合及时、详尽准确的要求。
      <br>
      1.2 您须对注册信息的真实性、合法性、有效性承担全部责任；不得冒充他人，不得利用他人的名义发布任何信息；不得恶意使用注册账号导致其他用户误认；否则广联达有权立即停止提供服务，由您独自承担由此而产生的一切法律责任。
      <br>
      1.3 您使用广联达产品、服务的行为必须合法，您必须为自己注册账号下的一切行为负责，包括您所发表的任何内容以及由此产生的任何结果。您应对其中的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。广联达不会对因您的行为而导致的任何损失或损害承担责任。
      <br>
      1.4 您须对自己的登录信息保密、不被其他人获取并使用并且对您在本网站账户下的所有行为负责。您必须将任何有可能触犯法律的，未授权使用或怀疑为未授权使用的行为在第一时间通知广联达，广联达不对您因未能遵守上述要求而造成的损失承担责任。
      <br>
      1.5 您不应将您的账号、密码转让、出售或出借予他人使用，若您授权他人使用账户，应对被授权人在该账号下发生所有行为负全部责任。
      <br>
    </div>
    <div class="part">
      二、服务内容
      <br>
      2.1您了解并同意，在您使用广联达造价云管理平台服务时，您将享受到的我方提供的服务包括：工程资料存储、工程资料管理、造价数据存储、造价数据查询、以及基于造价云云空间的云存档、智能组价、组价方案、云检查、查询我的数据、特征及内容、指标等服务。
      <br>
      2.2您了解并同意，使用广联达造价云管理平台服务产生的业务数据会随着工程文件和创建工程的广联云账号数据进行存储与复用。
      <br>
      <!-- 以下内容 2020.10月迭代有修改 -->
      <!--
      2.3您需要了解，如您不同意本协议，将无法使用广联达造价云管理平台服务以及云端的其他数据服务，例如云存档、智能组价、组价方案、云检查、查询我的数据、特征及内容、指标等。
      <br>
      2.4除非本协议另有其它明示规定，广联达造价云管理平台服务推出的新功能、新服务，均受到本协议之规范。
      <br>
      2.5您明确同意使用广联达产品和服务所存在的风险将完全由自己承担。您理解并接受下载或通过广联达服务取得的任何信息资料取决于您自己，并由您承担系统受损、资料丢失以及其它任何风险。
      <br>
      -->
      2.3您了解并同意，使用广联达造价云管理平台服务时，必须遵守中华人民共和国相关法律法规的规定，您同意将不会利用广联达服务进行任何违法或不正当的活动，包括但不限于下列行为∶
      <p style="padding-left: 24px; box-sizing: border-box;">
        2.3.1违背《中华人民共和国宪法》所确立的基本原则的；<br>
        2.3.2危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；<br>
        2.3.3损害国家荣誉和利益的；<br>
        2.3.4煽动民族仇恨、民族歧视、破坏民族团结的；<br>
        2.3.5破坏国家宗教政策，宣扬邪教和封建迷信的；<br>
        2.3.6散布谣言，扰乱社会秩序，破坏社会稳定的；<br>
        2.3.7散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；<br>
        2.3.8侮辱或者诽谤他人，侵害他人合法权利的；<br>
        2.3.9含有虚假、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、或其它有悖于道德的内容；<br>
        2.3.10含有中国法律、法规、规章、条例以及任何具有法律效力之规范所限制或禁止的其它内容的；<br>
      </p>
      <br>
      2.4您了解并同意，广联达或广联达委托的第三方有权对您使用广联达服务的行为及信息进行审查、监督及处理，包括但不限于用户信息（账号信息、个人信息等）、上传内容（如文字、图片、音频、视频、商标、专利、出版物等）等范畴。
      <br>
      2.5您需要了解，如您不同意本协议，将无法使用广联达造价云管理平台服务以及云端的其他数据服务，例如云存档、智能组价、组价方案、云检查、查询我的数据、特征及内容、指标等。
      <br>
      2.6您需要了解，如您违反本协议或相关的服务条款的规定，并因此导致任何第三方主张的任何索赔、要求或损失（包括合理的律师费）， 您同意赔偿广联达及其合作公司、关联公司，并使之免受损害。就此，广联达有权视您的行为性质，采取包括但不限于删除用户发布的信息内容、 暂停使用许可、终止服务、限制使用、收回广联达账号、追究法律责任等措施。对恶意注册广联达账号或利用广联达账号进行违法活动、干扰、骚扰、 欺骗其他用户以及其他违反本协议的行为，广联达有权收回其账号。同时，广联达将根据司法部门的要求，协助调查。
      <br>
      2.7除非本协议另有其它明示规定，广联达造价云管理平台服务推出的新功能、新服务，均受到本协议之规范。
      <br>
      2.8您明确同意使用广联达产品和服务所存在的风险将完全由自己承担。您理解并接受下载或通过广联达服务取得的任何信息资料取决于您自己，并由您承担系统受损、资料丢失以及其它任何风险。
      <br>
      <!-- 以上内容 2020.10月迭代有修改 -->
    </div>
    <div class="part">
      三、服务范围
      <br>
      3.1为了向您提供更好的服务与体验，我方会收集您的存档数据（如工程数据、组价方案、工料机、子目）、存档数据细部（如特征及内容、工料机含量等），并为您做数据推荐。
      <br>
      3.2您需要了解，我方收集您的数据仅供您本人使用，不会将您的数据直接用作他用。
      <br>
    </div>
    <div class="part">
      四、软件使用
      <br>
      4.1您可以通过登录zjy.glodon.com获得本软件的网页端服务，也可以下载造价云手机应用程序获取手机端的服务。
      <br>
      4.2如果您从非zjy.glodon.com的其他网址获取本软件的服务，我们无法保证该软件是否可以正常使用，并对于此给您造成的损失不予负责。
      <br>
      4.3我们可能为不同的终端设备开发了不同的手机应用程序版本，您应当根据实际情况选择下载合适的版本进行安装，且您不得将本软件安装在未经广联达明示许可的其他终端设备上。由于您未正确安装合适的软件版本所带来的风险及损失，我们不承担任何责任。
      <br>
      4.4您同意接受广联达造价云管理平台服务通过电子邮件或其他方式向您发送商品促销或其他相关商业信息。
      <br>
    </div>
    <div class="part">
      五、知识产权
      <br>
      5.1 广联达造价云管理平台产品中包含的任何文本、图片、图形、音频和/或视频资料均受版权、商标和/或其它财产所有权法律的保护，未经相关权利人同意，上述资料均不得在任何媒体直接或间接发布、播放、出于播放或发布目的而改写或再发行，或者被用于其他任何商业目的。
      <br>
      5.2 除非法律明文规定，否则您不得对广联达造价云管理平台产品及相关服务（包括但不限于内容或产品中的广告或赞助内容）的任何部分以任何形式或方法进行复制、发行、再版、下载、显示、张贴、修改、翻译、合并、利用、分解或反向编译等。
      <br>
      5.3您不得以创建相同或竞争服务为目的访问或使用广联达造价云管理平台产品及相关服务。
      <br>
    </div>
    <div class="part">
      六、用户信息保护
      <br>
      保护您个人信息是广联达造价云管理平台产品的一项重要原则，我们将会采取合理的措施保护您的个人信息，并对相关信息采用专业加密存储与传输方式，保障您个人信息的安全。有关用户个人信息保护详情参见《隐私政策》，您使用本服务应已了解并接受相关的《隐私政策》。
      <br>
    </div>
    <div class="part">
      七、免责声明
      <br>
      7.1广联达造价云管理平台产品有权利改善或更正本服务任何部分之任何疏漏、错误。
      <br>
      7.2广联达造价云管理平台产品不保证（包括但不限于）：
      <br>
      （1）提供的功能和服务适合您的使用要求；
      <br>
      （2）网络服务不受干扰，及时、安全、可靠或不出现错误，包括黑客入侵，网络中断，电信问题及其他不可抗力等；
      <br>
      （3）对于因不可抗力或广联达造价云管理平台产品不能控制的原因造成的网络服务中断或其它缺陷，广联达造价云管理平台产品不承担任何法律明确规定以外的责任，但将尽力减少因此而给您造成的损失和影响。
      <br>

    </div>
    <div class="part">
      八、协议修改
      <br>
      8.1本协议项下的服务由广联达造价云管理平台产品随时更新，更新后的协议将代替原协议条款，如您不接受修改后的协议条款，您有权选择停止使用服务；一旦您继续使用服务，则表示您已接受经修改的协议条款。当您与广联达造价云管理平台产品就本协议发生争议时，应以最新版本的服务协议为准。
      <br>
      8.2广联达造价云管理平台产品所提供的服务存在包括不可抗力、计算机病毒或黑客攻击、系统不稳定、您所在位置、通信线路、广联达造价云管理平台产品自身运营调整、合作伙伴调整等因素造成的服务中断或不能满足您要求的风险。
      <br>
      8.3您与广联达造价云管理平台产品均有权随时终止本协议，但您我之间存在尚未完成交易的除外，广联达造价云管理平台产品不承担任何责任。
      <br>
    </div>
    <div class="part">
      九、法律管辖
      <br>
      9.1本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律并受中国法院管辖。
      <br>
      9.2如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向北京市海淀区人民法院提起诉讼。
      <br>
    </div>
    <div class="part">
      十、其他规定
      <br>
      10.1本协议构成双方对本协议之约定事项及其他有关事宜的完整协议，除本协议规定的之外，未赋予本协议各方其他权利。
      <br>
      10.2如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。
      <br>
      10.3请查阅我们的《隐私条款》，《隐私条款》为本协议效力不可分割的一部分，且与本协议具有同等法律效力。
      <br>
    </div>
    <div class="part text--right">
      广联达科技股份有限公司
      <br>
      2019年03月25日
      <br>
    </div>
    <div class="part"></div>
  </div>
</template>
<style lang="less" type="text/less">
  @import "defaultStyle";
</style>
<script>
export default {
  name: 'UserAgreement'
}
</script>
